const INITIAL_APPLICATION_ALERTS_STATE_CONTENT = {
    message:  "",
    // The below properties are just for styling purposes.
    // They can be left as false by default, as the component will work normally without them.
    centered: false,
    rounded:  false,
};

export const INITIAL_APPLICATION_ALERTS_STATE = {
    success: INITIAL_APPLICATION_ALERTS_STATE_CONTENT,
    error:   INITIAL_APPLICATION_ALERTS_STATE_CONTENT
};
